export default {
  internal: {
    error: 'internal:error'
  },

  global: {
    providerStatusUpdate: 'global:providerStatusUpdate',
    reloadTranslations: 'global:reloadTranslations'
  },

  sport: {
    /*
      Events triggered on sport entity selecting
    */
    sportSelected: 'sport:sportSelected',
    categorySelected: 'sport:categorySelected',
    tournamentSelected: 'sport:tournamentSelected',
    eventSelected: 'sport:eventSelected',

    sportEventsCount: 'sport:sportEventsCount',
    categoryEventsCount: 'sport:categoryEventsCount',
    tournamentEventsCount: 'sport:tournamentEventsCount',

    /*
      Update for event
    */
    eventUpdate: 'sport:eventUpdate',
    tournamentUpdate: 'sport:tournamentUpdate',
    tournamentEventSportServiceUpdate: 'sport:tournamentEventSportServiceUpdate',

    /*
      Event triggered when events in one tournament load
    */
    tournamentEventsLoaded: 'sport:tournamentEventsLoaded',

    sportReInit: 'sport:re_init',
    sportEventUpdate: 'sport:event_update',
    sportLoadEvents: 'sport:load_events',
    sportLoadEventMarketGroup: 'sport:load_events_market_group',
    sportLoadSingleEvent: 'sport:load_single_event',
    sportLoadTournaments: 'sport:load_tournaments',
    sportLoadCategories: 'sport:load_categories'
  },

  socket: {
    /*
      Event triggered when subscribing on notifier topic
    */
    subscribe: 'socket:subscribe',

    /*
      Event triggered when subscribing on notifier topic
    */
    unsubscribe: 'socket:unsubscribe',

    /*
      Event triggered when connection reinitialized
      SubscriptionManager catching all subscriptions & re-sending all topics to notifier
    */
    resubscribe: 'socket:resubscribe',

    /*
      Event triggered once socket session initialized and recieved sessionId
    */
    session: 'socket:session',

    /*
      Event triggered when subscription manager receives data on an open socket connection
    */
    event: 'socket:event',

    /*
      When WSManager broadcating error event
    */
    error: 'socket:error',

    /*
      Event triggered when socket connection open
    */
    open: 'socket:open',
    /*
      Event triggered when socket connection closing
    */
    closed: 'socket:closed',

    /*
      Event triggered when subscription manager tries to reconnect
    */
    reconnect: 'socket:reconnect',

    /*
      Once reconnection attempts ended, event will be fired
    */
    reconnectFailed: 'socket:reconnectFailed'
  },

  bet: {
    snapshot: 'bet:snapshot',
    focus: 'bet:focus',

    placing: 'bet:placing',

    /*
      Event triggered when Bet manager successfully placed bet
    */
    placed: 'bet:placed',
    // placedSuccess: 'bet:placedSuccess', // used bet:placedResult instead
    placedFail: 'bet:placedFail',
    placedResult: 'bet:placedResult',
    interceptResolve: 'bet:interceptResolve',
    removeBetReport: 'bet:removeBetReport',

    /*
      Successfull order place event
    */
    orderSuccess: 'bet:orderSuccess',
    orderError: 'bet:orderError',

    /*
      BetManager validation events
    */
    validationSuccess: 'bet:validationSuccess',
    validationError: 'bet:validationError',

    /*
      Event triggered once Bet manager enable edit mode
    */
    edit: 'bet:edit',
    editCancel: 'bet:editCancel',

    /*
      Events depending on edit mode status changes
    */
    editSuccess: 'bet:editSuccess',
    editError: 'bet:editError',

    updated: 'bet:updated'
  },

  notification: {
    message: 'notification:message',
    showFlashMessage: 'notification:flash',
    showModalWindow: 'notification:modal'
  },

  /*
    Event triggered once settings been update

    Settings context must consume all updates by this event
    and provides data to the entire application
  */
  settings: {
    update: 'settings:update'
  },

  /*
    Event triggered once site configuration been resolved
  */
  config: {
    resolved: 'config:resolved',
    unresolved: 'config:unresolved'
  },

  auth: {
    /*
      Resolve events emitted on application initialization

      Event triggered once Account manager starts to resolve authentication
      if token exists in storage
    */
    resolving: 'auth:resolving',

    /*
      Event triggered once account by token resolved
    */
    resolved: 'auth:resolved',

    /*
      Event triggered once token not exists
      or when token not valid to resolve account profile data
    */
    unresolved: 'auth:unresolved',

    /*
      Successfull login event
    */
    login: 'auth:login',

    /*
      Failed login event
    */
    loginFailed: 'auth:loginFailed',

    /*
      Registration events

      Triggered on succesfull registration
    */
    registration: 'auth:registration',
    formRegistationSuccess: 'auth:formRegistationSuccess',

    /*
      Event triggered on failed registration attempt
    */
    registrationFailed: 'auth:registrationFailed',

    /*
      Event triggered when server response contents unauthorized error
      Applied authorization token to request is not valid
    */
    unauthorized: 'auth:unauthorized',

    /*
      Event triggered on Account manager logout or by server
    */
    logout: 'auth:logout',
    logoutSuccess: 'auth:logoutSuccess'
  },

  profile: {
    clientVerification: 'profile:verification',

    /*
      Event triggered once account profile data been changed,
      Data received from sockets or AccountUpdate form action
    */
    accountUpdate: 'profile:account_update',

    /*
      Event triggered once account balance changed
      Data received from sockets
    */
    balanceUpdate: 'profile:balance_update',
    bonusActivate: 'profile:bonus_activate',
    bonusDeactivate: 'profile:bonus_deactivate',
    bonusStatus: 'profile:bonus_status',
    bonusEligible: 'profile:bonus_eligible',
    bonusReload: 'profile:bonus_reload',

    bundleAssign: 'profile:bundle_assign',
    bundleDeactivate: 'profile:bundle_deactivate',
    bundleStatus: 'profile:bundle_status',
    bundleReload: 'profile:bundle_reload',

    betsCountUpdate: 'profile:betsCountUpdate',

    /*
      Event triggered once deposit has been completed
    */
    depositComplete: 'profile:depositComplete',

    /*
      Event triggered when ResponsibleGaming serivce broadcast notification RealityCheck
    */
    realityCheck: 'profile:reality_check',

    preferencesUpdate: 'profile:preferences_update',

    clientConfigChange: 'profile:config_change'
  },

  layout: {
    setLayout: 'layout:set_layout',
    setMobileDevice: 'layout:set_mobile_device',
    setSideBarLeft: 'layout:set_sidebar_left',
    setSideBarRight: 'layout:set_sidebar_right',
    setMainMenu: 'layout:set_main_menu',
    setLiveChat: 'layout:set_live_chat'
  },

  betSlip: {
    setBetSlip: 'betslip:set_betslip',
    setMode: 'betslip:set_betslip_mode'
  },

  racing: {
    raceUpdate: 'racing:race_update',
    raceStatusUpdate: 'racing:race_status_update',
    racingReInit: 'racing:re_init',
    loadNextRaces: 'racing:load_next_races',
    loadEventRunners: 'racing:load_event_runners',
    addBetslipRunners: 'racing:add_betslip_runners',
    clearBetslipRunners: 'racing:clear_betslip_runners',
    loadSingleRace: 'racing:load_single_race'
  }
}
